$(document).ready(function(){

 
    $('#readMore').click(function() { 
      $(this).hide();
})

 
       $(".news-section").slick({
          dots: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            
          ]
        });

//   $('.main .tab ul li a').on('click', function(){
//     var one = $(this).attr('data-link');

//     //var twoimg = $('.slider .item').attr('data-attr');

//     $('.slider').hide(1000);
//   });


//   $('.link').on('click', function(){
//     var link = $(this).attr('data-color');
//     $('.menu').css({'background': link});
//   });

$(function() {
  $(window).scroll(function(){
    var scrolltop=$(this).scrollTop();
    if(scrolltop>=100){
      $("#elevator_item").show();
    }else{
      $("#elevator_item").hide();
    }
  });
  $("#elevator").click(function(){
    $("html,body").animate({scrollTop: 0}, 500);
  });
  $(".qr").hover(function(){
    $(".qr-popup").show();
  },function(){
    $(".qr-popup").hide();
  });
});

$("#bar-icon").click(function(){
  $(".banner header .header-nav").addClass('mobile-menu-show');
});

$("#mobile-menu-hide").click(function(){
  $(".banner header .header-nav").removeClass('mobile-menu-show');
});

//   var myScroll;
//
// function loaded () {
// 	myScroll = new IScroll('#scroller-box', {
// 		scrollbars: true,
// 		mouseWheel: true,
// 		interactiveScrollbars: true,
// 		//shrinkScrollbars: 'scale',
// 		fadeScrollbars: false
// 	});
// }
//
// document.addEventListener('touchmove', function (e) { e.preventDefault(); }, false);

});